function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import typography from '../../utils/typography';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    optionsHeight
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => _objectSpread(_objectSpread(_objectSpread({
    boxSizing: 'border-box',
    listStyle: 'none',
    margin: 0,
    minWidth: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    padding: "calc(".concat(theme.layout.size2, " - 1px)"),
    pointerEvents: 'auto',
    userSelect: 'none',
    whiteSpace: 'nowrap'
  }, optionsHeight && {
    height: optionsHeight,
    overflowY: 'scroll'
  }), highContrastMediaQuery(theme)), {}, {
    '.vn-option': _objectSpread(_objectSpread({
      alignItems: 'center',
      border: '1px solid transparent',
      borderRadius: theme.borderRadius3,
      boxSizing: 'border-box',
      color: theme.palette.foreground.default,
      cursor: 'pointer',
      display: 'flex',
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size2,
      lineHeight: theme.typography.lineHeight3,
      padding: "6px ".concat(theme.layout.size2),
      pointerEvents: 'auto',
      position: 'relative',
      textDecoration: 'none',
      transition: 'background-color 100ms linear, color 100ms linear',
      userSelect: 'none'
    }, highContrastMediaQuery(theme)), {}, {
      '&.disabled': {
        color: theme.palette.foreground.disabled,
        cursor: 'auto'
      },
      '&:not(:last-of-type)': {
        marginBottom: theme.layout.size1
      },
      '> .icon_x': {
        display: 'none'
      },
      '&:not(.disabled)': _objectSpread({
        '&:hover': {
          backgroundColor: theme.palette.neutral.backgroundLight,
          color: theme.palette.foreground.default
        },
        '&[data-focus="true"]': {
          borderColor: theme.palette.primary.default,
          color: theme.palette.foreground.default
        },
        '&:active': {
          backgroundColor: theme.palette.neutral.background,
          color: theme.palette.foreground.default
        },
        '&[aria-selected="true"]': {
          backgroundColor: theme.palette.primary.default,
          color: theme.palette.foreground.inverse,
          '&.multiple': {
            backgroundColor: theme.palette.primary.default,
            color: theme.palette.foreground.inverse
          },
          '> .icon_x': {
            fill: theme.palette.foreground.inverse
          },
          '> .icon_checkmark': {
            display: 'block',
            fill: theme.palette.foreground.inverse
          },
          '&[data-focus="true"]': {
            backgroundColor: theme.palette.primary.hover,
            color: theme.palette.foreground.inverse,
            '> .icon_checkmark': {
              display: 'none'
            },
            '> .icon_x': {
              display: 'block'
            }
          },
          '&:active': {
            backgroundColor: theme.palette.primary.active,
            color: theme.palette.foreground.inverse
          }
        }
      }, theme.mode === 'contrast' && {
        color: theme.palette.primary.default,
        '&:hover': {
          backgroundColor: theme.palette.primary.hover,
          color: theme.palette.foreground.inverse
        },
        '&[data-focus="true"]': {
          backgroundColor: theme.palette.primary.hover,
          borderColor: theme.palette.primary.default,
          color: theme.palette.foreground.inverse
        },
        '&:active': {
          backgroundColor: theme.palette.primary.active,
          color: theme.palette.foreground.inverse
        },
        '&[aria-selected="true"]': {
          backgroundColor: theme.palette.primary.default,
          color: theme.palette.foreground.inverse,
          '&.multiple': {
            backgroundColor: theme.palette.primary.default,
            color: theme.palette.foreground.inverse
          },
          '&[data-focus="true"]': {
            backgroundColor: theme.palette.primary.hover,
            color: theme.palette.foreground.inverse,
            '> .icon_checkmark': {
              display: 'none'
            },
            '> .icon_x': {
              display: 'block'
            }
          },
          '&:active': {
            backgroundColor: theme.palette.primary.active,
            color: theme.palette.foreground.inverse
          }
        }
      }),
      '&__label': _objectSpread(_objectSpread({
        display: 'inline-flex',
        alignItems: 'center'
      }, typography(theme).label), {}, {
        minHeight: theme.layout.size6,
        overflow: 'hidden',
        '> span': {
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }),
      '&__icon': {
        marginRight: theme.layout.size2
      },
      '&__iconbutton': {
        color: 'inherit',
        height: theme.layout.size4,
        marginRight: theme.layout.size2,
        width: theme.layout.size4
      },
      '&.icon': {
        '.vn-option__iconbutton': {
          marginRight: "calc(".concat(theme.layout.size1, " / 2)")
        }
      },
      '&.vn-icon': {
        '.vn-option__icon': {
          color: 'inherit'
        }
      }
    })
  }), [theme, optionsHeight]);
};
export default useStyles;